import http from "../http/http-config";
import { CalculatePRET } from "../models/calculatorPRETResponse";

export default new class calculatorPRETService {
    calculatePRET(genderType, age, currencyType, amount): Promise<CalculatePRET> {
        return http.get<CalculatePRET>("CalculatorPRET", {
            params: {
                GenderType: genderType,
                Age: age,
                currencyType: currencyType,
                Amount: amount
            }
        }).then(response => response.data);
    }


}

